// One-shot IntersectionObserver reveal for non-supporting browsers only.
// Supporting browsers (Chrome/Edge with animation-timeline) skip entirely.
let observer: IntersectionObserver | null = null;

export function initIoReveal(): void {
  if (CSS.supports("animation-timeline: view()")) return;

  if (!observer) {
    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("io-reveal--in");
            observer!.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 },
    );
  }

  document.querySelectorAll<HTMLElement>(".io-reveal:not(.io-reveal--in)").forEach((el) => observer!.observe(el));
}

document.addEventListener("htmx:load", initIoReveal);
